import { Link } from 'react-router-dom';

export default function LegalFooter() {
  return (
    <footer className="border-t border-gray-200 py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Legal Disclaimer */}
        <div className="text-center mb-6">
          <p className="text-gray-600 text-sm leading-relaxed max-w-3xl mx-auto" data-testid="legal-disclaimer">
            This is a Free Draw operated in accordance with the Gambling Act 2005. No purchase is necessary to enter or win.
            See <Link to="/terms" className="text-[#EAB308] hover:underline">Terms & Conditions</Link> for free entry route details.
          </p>
          <p className="text-gray-500 text-xs mt-2" data-testid="eligibility-footer">
            Open to UK residents aged 18+. Free and paid entries carry equal weight in the draw.
          </p>
        </div>

        {/* Links */}
        <div className="flex items-center justify-center gap-4 mb-6" data-testid="footer-links">
          <Link to="/terms" className="text-[#EAB308] hover:underline text-sm" data-testid="footer-terms-link">
            Terms & Conditions
          </Link>
          <span className="text-gray-300">|</span>
          <Link to="/privacy" className="text-[#EAB308] hover:underline text-sm" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
        </div>

        {/* Company Info - Fixed formatting */}
        <div className="text-center space-y-1.5" data-testid="company-info">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Boss Win. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs leading-relaxed">
            Operated by Botelho Brothers Construction Ltd
          </p>
          <p className="text-gray-400 text-xs leading-relaxed">
            Companies House No. 15154170
          </p>
          <p className="text-gray-400 text-xs leading-relaxed">
            20 Elm Road, Thornton Heath, CR7 8RH, United Kingdom
          </p>
        </div>
      </div>
    </footer>
  );
}
